import { DisplayOnce } from "src/utils/fw"
import algosec from "../booths/algosec"
import bluevoyant from "../booths/bluevoyant"
import { textModal } from "../booths/common"
import crowdstrike from "../booths/crowdstrike"
import cybelangel from "../booths/cybelangel"
import huawei from "../booths/huawei"
import ibm from "../booths/ibm"
import kpmg from "../booths/kpmg"
import reliaquest from "../booths/reliaquest"
import securityscorecard from "../booths/securityscorecard"
import surecloud from "../booths/surecloud"

export const BoothThree = {
    body: {
        background: "https://assets.swoogo.com/uploads/full/2187919-636d17597c32b.jpg",
        name: "Room Three",
        links: [
            ...reliaquest,
            ...crowdstrike,
            ...cybelangel,
            ...algosec,
            ...securityscorecard,
            ...surecloud,
            ...bluevoyant,
            {
                width: "16.3%",
                height: "7%",
                left: "24.1%",
                top: "90%",
                label: "Room Two",
                href: "/Room-Two"
            },
            {
                width: "17.6%",
                height: "7%",
                left: "41.1%",
                top: "90%",
                label: "Exibition Hall",
                href: "/Exibition-Hall"
            },
            {
                width: "16%",
                height: "7%",
                left: "59.6%",
                top: "90%",
                label: "Room One",
                href: "/Room-One"
            }
        ]
    },
    location: "/Room-Three"
}

export const BoothTwo = {
    body: {
        background: "https://assets.swoogo.com/uploads/full/2182029-636a704ec06fc.jpg",
        name: "Room Two",
        extras: <DisplayOnce id="ibm-booth-4" { ...textModal("30%") }>
            <p>
                When you interact with IBM, this serves as your authorisation to The ISF to provide 
                your contact information to IBM in order for IBM to follow up on your interaction.
            </p>
            <p>
                IBM’s use of your contact information is governed by the <a style={{textDecoration: "underline"}} href="http://ibm.com/us-en/privacy">IBM Privacy Policy</a>
            </p>
        </DisplayOnce>,
        links: [
            ...huawei,
            ...ibm,
            {
                width: "16.3%",
                height: "7%",
                left: "24.1%",
                top: "90%",
                label: "Room One",
                href: "/Room-One"
            },
            {
                width: "17.6%",
                height: "7%",
                left: "41.1%",
                top: "90%",
                label: "Exibition Hall",
                href: "/Exibition-Hall"
            },
            {
                width: "16%",
                height: "7%",
                left: "59.6%",
                top: "90%",
                label: "Room Three",
                href: "/Room-Three"
            }
        ]
    },
    location: "/Room-Two"
}

export const BoothOne = {
    body: {
        background: "https://assets.swoogo.com/uploads/full/2169901-6362905855ead.jpg",
        name: "Room One",
        links: [
            ...kpmg,
            {
                width: "16.3%",
                height: "7%",
                left: "24.1%",
                top: "90%",
                label: "Room Three",
                href: "/Room-Three"
            },
            {
                width: "17.6%",
                height: "7%",
                left: "41.1%",
                top: "90%",
                label: "Exibition Hall",
                href: "/Exibition-Hall"
            },
            {
                width: "16%",
                height: "7%",
                left: "59.6%",
                top: "90%",
                label: "Room Two",
                href: "/Room-Two"
            }
        ]
    },
    location: "/Room-One"
}